export default "__VITE_ASSET__Brh7sOqS__"